import styled from "@emotion/styled";
import { ReactElement, useCallback, useState } from "react";

import { Button, DesignToken, Text } from "@livechat/design-system-react-components";

import { ITeam } from "store/entities/teams";
import { withVar } from "themes/helpers";

interface ITeamsPreviewProps {
  teams: ITeam[];
  previewCount?: number;
}

const TeamsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    padding: 0;
    margin: 0;
  }
`;

export const TeamsPreview = ({ teams, previewCount = 1 }: ITeamsPreviewProps): ReactElement => {
  const [expanded, toggleExpanded] = useState(false);
  const displayedItems = !expanded ? teams.slice(0, previewCount) : teams;

  const handleToggle = useCallback(() => {
    toggleExpanded(!expanded);
  }, [expanded]);
  if (teams.length === 0) {
    return <>-</>;
  }
  return (
    <TeamsList>
      {displayedItems.map(team => (
        <li key={team.id}>
          <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>
            {team.name} {team.isDefault && <>(Default team)</>}
            {!expanded && teams.length > 1 && ` + ${teams.length - 1}`}
          </Text>
        </li>
      ))}
      {teams.length > previewCount && (
        <li>
          <Button kind="link" onClick={handleToggle}>
            {expanded ? "Show less" : "Show more"}
          </Button>
        </li>
      )}
    </TeamsList>
  );
};
